import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../../../../store/store';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import MedicalReportSlovakia from '../../../../Components/MedicalReport/Slovakia/MedicalReportSlovakia';

loadDOMComponent({
	selector: 'react-development',
	callback: ({ container, context }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<MedicalReportSlovakia
							workplaceId=''
							onSuccess={() => {}}
							loggedUserId=''
							patientId=''
							isMeddiCase={false}
							disableSubmit={false}
							defaultValues={{}}
						/>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
